import React from "react";
import { styled } from "@washingtonpost/wpds-ui-kit";

const SwipeUpButtonWrapper = styled("div", {
  position: "absolute",
  bottom: 0,
  fontSize: "$075",
  fontWeight: "$bold",
  width: "100%",
  marginBottom: "$050",
  "@media (min-width: 480px)": {
    display: "none"
  }
});

export const SwipeUp = () => {
  return (
    <SwipeUpButtonWrapper>
      <p style={{ margin: 0 }}>Swipe up for next video</p>
    </SwipeUpButtonWrapper>
  );
};
